import React from 'react';
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';
import './StatsOverview.css';

export interface StatItem {
  title: string;
  value: React.ReactNode;
}

/**
 * Renders a horizontal, scroll-snap list of cards,
 * all wrapped in an outer IonCard container.
 */
const StatsOverview: React.FC<{ items: StatItem[] }> = ({ items }) => (
  <IonCard className="stats-overview-container welcome-card">
    <IonCardHeader className="stats-overview-heading">
      <img
        src="/assets/ploppy/ploppy-stats-celebrate.png"
        alt="Ploppy celebrating"
      />
      <div>
        <span>Progress worth celebrating</span>
        <IonCardTitle>Your stats</IonCardTitle>
        <p>Every workout adds a little more to your story.</p>
      </div>
    </IonCardHeader>
    <IonCardContent className="stats-overview-content">
      <div className="stats-snap-container">
        {items.map((item, idx) => (
          <IonCard
            className={`stats-card stats-card--tone-${(idx % 3) + 1}`}
            key={idx}
          >
            <IonCardHeader>
              <IonCardTitle className="stats-card__title">
                {item.title}
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent className="stats-card__content">
              {item.value}
            </IonCardContent>
          </IonCard>
        ))}
      </div>
    </IonCardContent>
  </IonCard>
);

export default StatsOverview;
